export default {
    namespaced: true,
    actions: {
        present() {
            $(".content").preloader({
                zIndex: "1000",
                text: "Procesando . . .",
            });
        },
        dismiss() {
            $(".content").preloader("remove");
        },
    },
};
